export class ImageKindConstant {
  static large = "LARGE";
  static cont1 = "CONT_1";
  static cont2 = "CONT_2";
}